export default "__VITE_ASSET__DxHRzqTL__"